import { type ClassValue, clsx } from "clsx"
import { twMerge } from "./twMerge"

export const classNames = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}
